import { useContext } from 'react';
import { AuthenticationContext } from '../context/AuthenticationProvider/AuthenticationProvider';

export const useAuthentication = (): any => {
  return useContext(AuthenticationContext);
};
